import { CARD_SIZES } from "@/constants/guardians"

export function getCardDimensions(size: keyof typeof CARD_SIZES) {
  const width = CARD_SIZES[size]
  const height = width * 1.45
  return { width, height }
}
